import { ExternalLink } from 'lucide-react';
import { euro } from '../lib/api';
import { STALE_DAYS, type StaleBasis, type StaleDeal } from '../../shared/kpi';

/**
 * Die Überschrift richtet sich nach `staleBasis`. `Stage_Modified_Time` steht am
 * Deal und beantwortet „ohne Stufenänderung" exakt; fehlt das Feld an einzelnen
 * Deals, wird auf die letzte Aktivität zurückgefallen – dann muss die Kachel
 * auch so heissen. Eine Kachel, die das Falsche behauptet, ist schlimmer als
 * eine, die fehlt.
 */
export function staleTitle(basis: StaleBasis): string {
  return basis === 'stage-change'
    ? `Ohne Stufenänderung über ${STALE_DAYS} Tage`
    : `Ohne Bewegung über ${STALE_DAYS} Tage`;
}

export function StaleList({ deals, basis }: { deals: StaleDeal[]; basis: StaleBasis }) {
  if (deals.length === 0) return <p className="card__meta">Nichts liegen geblieben.</p>;
  return (
    <>
      <div className="sm-stale">
        {deals.map((d) => (
          <div className="sm-stale__row" key={d.id}>
            <span>
              {/* Kunde zuerst: ein Deal-Name wie „4x BP-60C31" sagt allein nichts. */}
              <span className="sm-stale__customer">{d.customer ?? 'ohne Kunde'}</span>
              <br />
              {d.url ? (
                <a href={d.url} target="_blank" rel="noreferrer noopener" className="linkbtn">
                  {d.name} <ExternalLink size={12} />
                </a>
              ) : (
                d.name
              )}
              <span className="card__meta"> · {d.stage}</span>
            </span>
            <span className="sm-stale__days mono">
              {d.days} Tage
              {d.amount > 0 ? <span className="card__meta"> · {euro(d.amount)}</span> : null}
            </span>
          </div>
        ))}
      </div>
      {basis === 'activity' && (
        <p className="card__meta" style={{ marginTop: '0.5rem' }}>
          Bei einzelnen Deals fehlt im CRM der Zeitpunkt der letzten Stufenänderung. Für die zählt
          die letzte Aktivität am Datensatz – deshalb „ohne Bewegung" statt „ohne Stufenänderung".
        </p>
      )}
    </>
  );
}
